import type { InterviewPersonaLike } from '@/features/sessions';
import type { Persona } from '@/entities/persona';

export function mapPersonaToInterviewPersona(persona: Persona): InterviewPersonaLike {
  return {
    id: persona.id,
    firstName: persona.demographicsData?.data.firstName ?? '',
    age: persona.demographicsData?.data.age ?? '',
    segmentName: persona.segmentName ?? '',
    segmentDescription: persona.segmentDescription,
    personaBrief: persona.personaBrief,
    personaTitle: persona.personaTitle,
    photoAssetId: persona.photoAssetId,
    tags: persona.psychometricsData?.characteristics.slice(0, 3) ?? [],
  };
}
